import { ComponentType } from 'react';

import Loadable from '@townsquare/loadable';
import type { LoadableComponent } from '@townsquare/loadable/types';

export const ErrorScreen: ComponentType<unknown> & LoadableComponent = Loadable({
	loader: () => import(/* webpackChunkName: "Bootstrap_ErrorScreen" */ './Error'),
	loading: () => null,
});

export const ForbiddenScreen: ComponentType<unknown> & LoadableComponent = Loadable({
	loader: () => import(/* webpackChunkName: "Bootstrap_ForbiddenScreen" */ './Forbidden'),
	loading: () => null,
});

export const RestrictedGoalForbiddenScreen: ComponentType<unknown> & LoadableComponent = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "Bootstrap_RestrictedGoalForbiddenScreen" */ './RestrictedGoalForbidden'
		),
	loading: () => null,
});

export const NotFoundScreen: ComponentType<unknown> & LoadableComponent = Loadable({
	loader: () => import(/* webpackChunkName: "Bootstrap_NotFoundScreen" */ './NotFound'),
	loading: () => null,
});
